exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dataImportModal .v--modal-box.v--modal{min-height:375px!important;min-width:670px!important}#dataImportModal .v-tabs__div:not(:last-child){padding-right:5px}#dataImportModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#dataImportModal .checkbox--big i{font-size:20px}#dataImportModal .modal__footer{display:none!important}#dataImportModal .v-btn.success{margin-left:0}#dataImportModal .v-select__selection.v-select__selection--comma{font-size:12px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-341d2564","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/DataImportModal.vue
// module id = 2008
// module chunks = 0